import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { experienceOptions } from 'utils/constants';

const ExperienceFilter = ({ className, handleTabChange, activeTab }) => {
  const ExperienceTabs = () => {
    return (
      <>
        {experienceOptions.map((experience) => (
          <button
            className={classnames(
              'rounded-full w-10/12 py-2 md:py-3 text-black',
              {
                'text-white bg-gradient-turqoise-violet':
                  activeTab === experience,
              }
            )}
            key={experience}
            type="button"
            onClick={() => handleTabChange(experience)}
          >
            {experience}
          </button>
        ))}
      </>
    );
  };

  return (
    <div
      className={classnames(
        'lg:w-9/12 xl:w-7/12 text-white px-4 sm:mx-auto flex flex-col items-center justify-center text-center pt-5 z-20 overflow-visible gap-4',
        className
      )}
    >
      <h2 className="font-light z-20" style={{ fontSize: 32 }}>Our Membership Tiers</h2>
      <p className="text-base font-light z-20 max-w-2xl">
        Joining Gig Life Pro is a valuable tool for anybody building a career in the music industry.
      </p>
    </div>
  );
};

ExperienceFilter.propTypes = {
  className: PropTypes.string,
  handleTabChange: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
};

ExperienceFilter.defaultProps = {
  className: null,
};

export default ExperienceFilter;
